import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { InputLabel, PasswordForm, PasswordInput, PasswordInputContainer, PasswordInputContainerLast, ShowHidePassword } from './styled';
const SetPasswordView = _ref => {
  let {
    state,
    setState,
    error
  } = _ref;
  const [showPassword, setShowPassword] = useState(false);
  const {
    password,
    confirmPassword
  } = state;
  const inputType = showPassword ? 'text' : 'password';
  const passwordIcon = showPassword ? faEye : faEyeSlash;
  const handleInputChange = event => {
    const value = event.currentTarget.value;
    const name = event.currentTarget.name;
    setState(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleTogglePassword = () => {
    setShowPassword(prevState => !prevState);
  };
  return /*#__PURE__*/React.createElement(PasswordForm, null, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "password"
  }, "Nouveau mot de passe"), /*#__PURE__*/React.createElement(PasswordInputContainer, null, /*#__PURE__*/React.createElement(PasswordInput, {
    type: inputType,
    id: "password",
    name: "password",
    value: password,
    onChange: handleInputChange,
    error: !!error,
    autoComplete: "password"
  }), /*#__PURE__*/React.createElement(ShowHidePassword, {
    showPassword: showPassword,
    onClick: handleTogglePassword
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: passwordIcon
  }))), /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "confirmPassword"
  }, "Confirmation"), /*#__PURE__*/React.createElement(PasswordInputContainerLast, null, /*#__PURE__*/React.createElement(PasswordInput, {
    type: inputType,
    id: "confirmPassword",
    name: "confirmPassword",
    value: confirmPassword,
    onChange: handleInputChange,
    error: !!error,
    autoComplete: "confirmPassword"
  }), /*#__PURE__*/React.createElement(ShowHidePassword, {
    showPassword: showPassword,
    onClick: handleTogglePassword
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: passwordIcon
  }))));
};
SetPasswordView.propTypes = {
  state: PropTypes.shape({
    password: PropTypes.string.isRequired,
    confirmPassword: PropTypes.string.isRequired
  }),
  setState: PropTypes.func.isRequired,
  error: PropTypes.object
};
export default SetPasswordView;